import { AccountContext } from "context/account";
import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import { backendServer } from "services/request";
import socketIOClient from "socket.io-client";

import api from "../services/api";

const defaultCounterContext = {
  count: 0,
  gcount: 0,
  pcount: 0,
  ccount: 0,
  pgcount: 0,
  ncount: 0,
  unreadRequestCount: 0,
  getNewMessageCount: () => {},
  getUnreadMessageCount: () => {},
  setUnreadRequestCount: () => {},
};

const CounterContext = createContext(defaultCounterContext);
export default CounterContext;

export const CounterProvider = (props) => {
  const [count, setCount] = useState(defaultCounterContext.count);
  const [gcount, setGCount] = useState(defaultCounterContext.gcount);
  const [pcount, setPCount] = useState(defaultCounterContext.pcount);
  const [ccount, setCCount] = useState(defaultCounterContext.ccount);
  const [pgcount, setPGCount] = useState(defaultCounterContext.pgcount);
  const [ncount, setNCount] = useState(defaultCounterContext.ncount);
  const [unreadRequestCount, setUnreadRequestCount] = useState(
    defaultCounterContext.unreadRequestCount
  );

  const account = useContext(AccountContext);
  const NEW_CHAT_MESSAGE_EVENT = "newChatMessage"; // Name of the event
  const socketRef = useRef(null);

  useEffect(() => {
    if (account.id) {
      getNewMessageCount();
      let roomId = account.id;
      socketRef.current = socketIOClient(backendServer, {
        query: { roomId },
      });
      socketRef.current.on(NEW_CHAT_MESSAGE_EVENT, (message) => {
        getNewMessageCount();
      });
      return () => {
        socketRef.current?.disconnect();
      };
    }
  }, [account.id]);

  const sendCountSignal = (userid) => {
    try {
      socketRef.current?.emit(NEW_CHAT_MESSAGE_EVENT, {
        body: "",
        senderId: account.id,
        contacts: [{ id: userid }],
      });
    } catch (err) {
      console.log(err);
    }
  };

  const getNewMessageCount = async () => {
    try {
      const { data } = await api.chatroom.newMessageCounts();
      setCount(data?.count || 0);
      setGCount(data?.gcount || 0);
      setPCount(data?.pcount || 0);
      setPGCount(data?.pgcount || 0);
      setCCount(data?.ccount || 0);
      setNCount(data?.ncount || 0);
    } catch (err) {
      console.log(err);
    }
  };

  const getUnreadMessageCount = async (userId) => {
    if (!userId) {
      return;
    }
    try {
      const payload = {
        filter: `((status='requested')) AND (audiences='${userId}')`,
        limit: 500,
      };
      const { data } = await api.project.search(payload);
      const myProjects = data?.hits || [];

      const eventList = await api.event.list({ resource_type: "prospect", user_id: userId });
      const user_view = eventList?.data?.user_view || [];
      let readStatusMap = {};
      for (let i = 0; i < user_view.length; i++) {
        if (user_view[i]?.resource_id && user_view[i]?.action == "viewed") {
          const p_id = user_view[i].resource_id;
          readStatusMap[p_id] = true; //read
        }
      }
      let newCount = 0;
      let ids = [];
      for (let i = 0; i < myProjects.length; i++) {
        if (!readStatusMap[myProjects[i].id]) {
          newCount++;
        }
        ids.push(myProjects[i].id);
      }

      setUnreadRequestCount(newCount);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <CounterContext.Provider
      {...props}
      value={{
        ...defaultCounterContext,
        count,
        gcount,
        pcount,
        pgcount,
        ccount,
        ncount,
        unreadRequestCount,
        getNewMessageCount,
        getUnreadMessageCount,
        setUnreadRequestCount,
        sendCountSignal,
      }}
    />
  );
};
